angular.module("avant.tealium", []);

require('./tealiumService.coffee');
